<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Header -->
        <KTHeader></KTHeader>
        <QuickAccessTray />
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-if="showDashboardAnnouncement"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid,
              }"
            >
              <aside
                v-if="showDashboardSubscriptionAlert"
                class="dashboard-subscription-alert"
                :class="`dashboard-subscription-alert--${subscriptionNotice.tone}`"
                role="alert"
              >
                <div class="dashboard-subscription-alert__icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="dashboard-subscription-alert__content">
                  <strong>{{ subscriptionNotice.title }}</strong>
                  <span>{{ subscriptionNotice.description }}</span>
                </div>
                <router-link to="/subscribe/package" class="dashboard-subscription-alert__action">
                  {{ subscriptionNotice.action }}
                  <i class="fas fa-arrow-right"></i>
                </router-link>
              </aside>

              <transition name="subscription-notice">
                <aside
                  v-if="showFloatingSubscriptionNotice"
                  class="subscription-notice"
                  :class="`subscription-notice--${subscriptionNotice.tone}`"
                  role="status"
                  aria-live="polite"
                  aria-atomic="true"
                >
                  <div class="subscription-notice__icon" aria-hidden="true">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M10.3 4.1L2.7 17.2A2 2 0 004.4 20h15.2a2 2 0 001.7-2.8L13.7 4.1a2 2 0 00-3.4 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 9v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                      <circle cx="12" cy="16.5" r="1" fill="currentColor"/>
                    </svg>
                  </div>

                  <div class="subscription-notice__content">
                    <div class="subscription-notice__title-row">
                      <strong class="subscription-notice__title">
                        {{ subscriptionNotice.title }}
                      </strong>
                      <span
                        v-if="subscriptionNotice.days > 0"
                        class="subscription-notice__badge"
                      >
                        {{ subscriptionNotice.days }} hari
                      </span>
                    </div>
                    <p class="subscription-notice__description">
                      {{ subscriptionNotice.description }}
                      <router-link
                        to="/subscribe/package"
                        class="subscription-notice__action"
                      >
                        {{ subscriptionNotice.action }}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </router-link>
                    </p>
                  </div>

                  <button
                    type="button"
                    class="subscription-notice__close"
                    aria-label="Tutup pemberitahuan langganan"
                    title="Tutup"
                    @click="dismissSubscriptionNotice"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </aside>
              </transition>
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>
    <!-- <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar> -->
    <KTScrollTop></KTScrollTop>
    <MedhopAssistant />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import QuickAccessTray from "@/view/layout/header/QuickAccessTray.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
// import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import MedhopAssistant from "@/view/layout/assistant/MedhopAssistant.vue";
import {
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

import module from "@/core/modules/CrudModule.js";
import ProductConfigurationService from "@/core/services/product-configuration.service.js";
import {
  setConfiguration,
  getConfiguration,
} from "@/core/services/jwt.service.js";

export default {
  name: "Layout",

  components: {
    KTAside,
    KTHeader,
    QuickAccessTray,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    // KTStickyToolbar,
    KTScrollTop,
    MedhopAssistant,
  },

  data() {
    return {
      tenantConfig: {},
      subscriptionNoticeDismissed: false,
    };
  },

  beforeMount() {
    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },

  mounted() {
    this.setTenantConfig();
    ProductConfigurationService.refresh().catch(() => {});
    // update subscrie data
    this.$root.$on("subUpdate", () => {
      this.setTenantConfig();
      // this.tenantConfig = value;
    });

    // this.getDbConfig()
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    // if (getConfiguration() == null) {
    //   this.getSetting()
    // }
    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");

    // Simulate the delay page loading
    // setTimeout(() => {
    //   // Remove page loader after some time
    //   this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    // }, 3000);
  },

  methods: {
    setTenantConfig() {
      this.tenantConfig = JSON.parse(localStorage.getItem("tenantconfig"));
      this.syncSubscriptionNoticeSession();
    },

    dismissSubscriptionNotice() {
      this.subscriptionNoticeDismissed = true;
      try {
        sessionStorage.setItem(this.subscriptionNoticeSessionKey(), "1");
      } catch (error) {
        // Session storage tidak tersedia; state komponen tetap mencegah popup berulang.
      }
    },

    subscriptionNoticeSessionKey() {
      const config = this.tenantConfig || {};
      let user = {};
      try {
        user = JSON.parse(localStorage.getItem("user")) || {};
      } catch (error) {
        user = {};
      }
      const tenant = config.database_name || config.id || "tenant";
      const userId = user.id || user.user_id || "user";
      return `medhop:subscription-notice:${tenant}:${userId}`;
    },

    syncSubscriptionNoticeSession() {
      try {
        this.subscriptionNoticeDismissed =
          sessionStorage.getItem(this.subscriptionNoticeSessionKey()) === "1";
      } catch (error) {
        this.subscriptionNoticeDismissed = false;
      }

      this.$nextTick(() => {
        if (
          this.subscriptionNotice &&
          !this.subscriptionNoticeUrgent &&
          !this.subscriptionNoticeDismissed
        ) {
          try {
            sessionStorage.setItem(this.subscriptionNoticeSessionKey(), "1");
          } catch (error) {
            // Popup tetap tampil sekali selama instance Layout aktif.
          }
        }
      });
    },

    async getDbConfig() {
      let response = await module.getDbConfig(
        "get-db-config?domain=hayandra.medhop.id"
      );
      // If Data Found
      if (response != null) {
        window.localStorage.setItem(
          "dbconfiguration",
          JSON.stringify(response)
        );
        window.dbconfiguration = response;
      }
    },
    async getSetting(dbconfiguration) {
      let response = await module.get(
        `settings-no-auth/1?database_name=${dbconfiguration.database_name}&database_password=${dbconfiguration.database_password}&database_username=${dbconfiguration.database_username}`
      );
      // If Data Found
      if (response != null) {
        setConfiguration(JSON.stringify(response));
      }
    },
  },

  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),

    subscriptionNotice() {
      const config = this.tenantConfig || {};
      const subscriptionStatus = Number(config.is_subscribe);
      const days = Number(config.diff_date);

      if (!Number.isFinite(days)) {
        return null;
      }

      if (subscriptionStatus === 0 && days > 0) {
        return {
          tone: "warning",
          title: "Masa coba gratis segera berakhir",
          description: `Paket percobaan Anda tersisa ${days} hari.`,
          action: "Lihat paket langganan",
          days,
        };
      }

      if (subscriptionStatus === 1 && days > 0 && days < 8) {
        return {
          tone: "warning",
          title: "Langganan segera berakhir",
          description: `Masa aktif langganan Anda tersisa ${days} hari.`,
          action: "Perpanjang langganan",
          days,
        };
      }

      if (subscriptionStatus === 1 && days < 1) {
        return {
          tone: "danger",
          title: "Langganan telah berakhir",
          description: "Perpanjang paket untuk terus menggunakan seluruh layanan Medhop.",
          action: "Perpanjang sekarang",
          days: 0,
        };
      }

      if (subscriptionStatus === 0 && days < 1) {
        return {
          tone: "danger",
          title: "Masa coba gratis telah berakhir",
          description: "Pilih paket yang sesuai untuk melanjutkan penggunaan Medhop.",
          action: "Pilih paket langganan",
          days: 0,
        };
      }

      return null;
    },

    subscriptionNoticeUrgent() {
      return Boolean(
        this.subscriptionNotice && Number(this.subscriptionNotice.days) <= 7
      );
    },

    isMainDashboard() {
      return ["/dashboard", "/central-dashboard"].includes(this.$route.path);
    },

    showFloatingSubscriptionNotice() {
      return Boolean(
        this.subscriptionNotice &&
        !this.subscriptionNoticeUrgent &&
        !this.subscriptionNoticeDismissed
      );
    },

    showDashboardSubscriptionAlert() {
      return Boolean(
        this.subscriptionNotice &&
        this.subscriptionNoticeUrgent &&
        this.isMainDashboard
      );
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    showDashboardAnnouncement() {
      return this.subheaderDisplay && this.$route.name === "dashboard";
    },
  },
};
</script>

<style scoped>
#kt_content.content {
  padding-top: 8px !important;
}

.subscription-notice {
  --notice-color: #F59E0B;
  --notice-bg: #FFF8EB;
  --notice-border: #F8DFAD;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  gap: 14px;
  position: fixed;
  top: 88px;
  right: 24px;
  z-index: 1100;
  width: min(calc(100vw - 48px), 470px);
  max-width: 470px;
  min-height: 72px;
  margin: 0;
  padding: 16px;
  color: #1A2433;
  background: var(--notice-bg);
  border: 1px solid var(--notice-border);
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(var(--skin-deep-rgb), 0.1);
  transform-origin: right center;
  will-change: opacity, transform;
  transition: box-shadow 180ms ease, transform 180ms ease;
}

.subscription-notice:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 34px rgba(var(--skin-deep-rgb), 0.13);
}

.subscription-notice--danger {
  --notice-color: #EF4444;
  --notice-bg: #FEF2F2;
  --notice-border: #FECACA;
}

.subscription-notice__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: var(--notice-color);
  background: #FFFFFF;
  border: 1px solid var(--notice-border);
  border-radius: 11px;
  box-shadow: 0 4px 12px rgba(var(--skin-deep-rgb), 0.05);
  margin-top: 1px;
}

.subscription-notice__content {
  min-width: 0;
  padding-top: 1px;
}

.subscription-notice__title-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 4px;
}

.subscription-notice__title {
  width: auto !important;
  min-width: 0;
  flex: 0 1 auto;
  color: #1A2433;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.subscription-notice__badge {
  flex: 0 0 auto;
  padding: 2px 7px;
  color: var(--notice-color);
  background: #FFFFFF;
  border: 1px solid var(--notice-border);
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.subscription-notice__description {
  margin: 0;
  color: #6B7280;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
}

.subscription-notice__action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  color: var(--skin-primary);
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: color 180ms ease, gap 180ms ease;
}

.subscription-notice__action:hover,
.subscription-notice__action:focus {
  gap: 7px;
  color: var(--skin-deep);
  text-decoration: underline;
}

.subscription-notice__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  color: #6B7280;
  background: transparent;
  border: 0;
  border-radius: 10px;
  outline: 0;
  cursor: pointer;
  transition: color 180ms ease, background 180ms ease;
  margin: -2px -2px 0 0;
}

.subscription-notice__close:hover,
.subscription-notice__close:focus-visible {
  color: var(--skin-deep);
  background: rgba(var(--skin-deep-rgb), 0.08);
}

.subscription-notice-enter-active {
  animation: subscription-notice-in 480ms cubic-bezier(0.22, 1, 0.36, 1);
}

.subscription-notice-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.subscription-notice-leave-to {
  opacity: 0;
  transform: translateX(18px);
}

@keyframes subscription-notice-in {
  0% {
    opacity: 0;
    transform: translateX(28px) scale(0.97);
  }
  68% {
    opacity: 1;
    transform: translateX(-3px) scale(1.005);
  }
  100% {
    opacity: 1;
    transform: translateX(0) rotate(0) scale(1);
  }
}

.dashboard-subscription-alert {
  --alert-color: #D97706;
  --alert-bg: #FFFBEB;
  --alert-border: #FDE68A;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding: 14px 16px;
  color: #1A2433;
  background: var(--alert-bg);
  border: 1px solid var(--alert-border);
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(var(--skin-deep-rgb), 0.07);
}

.dashboard-subscription-alert--danger {
  --alert-color: #DC2626;
  --alert-bg: #FEF2F2;
  --alert-border: #FECACA;
}

.dashboard-subscription-alert__icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--alert-color);
  background: #FFFFFF;
  border: 1px solid var(--alert-border);
  border-radius: 11px;
}

.dashboard-subscription-alert__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dashboard-subscription-alert__content strong {
  font-size: 13px;
}

.dashboard-subscription-alert__content span {
  color: #64748B;
  font-size: 12px;
}

.dashboard-subscription-alert__action {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--skin-primary);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

@media (prefers-reduced-motion: reduce) {
  .subscription-notice,
  .subscription-notice-enter-active,
  .subscription-notice-leave-active {
    animation: none;
    transition: none;
  }
}

@media (max-width: 575.98px) {
  #kt_content.content {
    padding-top: 5px !important;
  }

  .subscription-notice {
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: start;
    gap: 12px;
    top: 72px;
    right: 12px;
    left: 12px;
    width: auto;
    max-width: none;
    min-height: 68px;
    padding: 14px 16px;
    border-radius: 14px;
  }

  .dashboard-subscription-alert {
    grid-template-columns: auto minmax(0, 1fr);
  }

  .dashboard-subscription-alert__action {
    grid-column: 2;
  }

  .subscription-notice__icon {
    width: 34px;
    height: 34px;
  }

  .subscription-notice__title-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .subscription-notice__action {
    display: flex;
    width: fit-content;
    margin: 5px 0 0;
  }
}
</style>


<style>
.btn-green {
  background-color: #43a047;
  border-color: #43a047;
}

.btn-outline-green {
  color: #43a047;
  background-color: transparent;
  border-color: #43a047;
}

.btn-outline-green:hover {
  color: white;
  background-color: #43a047;
  border-color: #43a047;
}

.btn-outline-green:hover i {
  color: white;
}

.btn-outline-green i {
  color: #43a047;
}

.text-green {
  color: #43a047;
}
</style>
